// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"123":"case","187":"search"}[chunkId] || chunkId) + "." + {"123":"6721d3cd69c269ceb3bb","187":"ab7f0b8d9fdb52231fc2","634":"d5fe3ba5826a0a012250"}[chunkId] + ".bundle.js";
};